import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import UserStore from 'stores/UserStore';
import CoachingStatsActions from 'actions/coaching/CoachingStatsActions';
import CoachingSkillVelocityChart from 'components/coaching/widgets/CoachingSkillVelocityChart';
import Loading from 'components/pure/utils/Loading';
import './CoachingSkillVelocityChartContainer.styl';
import {getPlanChartEnd} from 'components/coaching/coaching-goals-view/coaching-goals-view';

/**
 * Container to hook the skill velocity chart up to state.
 *
 * This is in charge of gathering the skill chart info from the API, but also interacts with properties passed in,
 * including the currently selected Review attached to the plan.
 */
class CoachingSkillVelocityChartContainer extends React.PureComponent {
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return {
      users: UserStore.getState().users,
    };
  }

  componentDidMount() {
    CoachingStatsActions.coachingStats.defer(this.props.coachingPlan.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.coachingPlan.id !== this.props.coachingPlan.id) {
      CoachingStatsActions.coachingStats.defer(nextProps.coachingPlan.id);
    }
  }

  render() {
    const {
      coachingPlan,
      planVelocity,
      coachingStats,
      coachingStatsLoading,
      contentDetail,
      currentReviewId,
    } = this.props;

    const reviewFeedback = coachingStats?.chart[contentDetail.id];
    if (
      !coachingStats ||
      coachingStatsLoading ||
      // this could happen if we have still the old chart in the store. just keep loading.
      !reviewFeedback ||
      !planVelocity
    ) {
      return <Loading />;
    }

    const planStart = coachingPlan.created.clone().subtract(1, 'days').toDate();
    const planEnd = getPlanChartEnd(planVelocity, coachingPlan);
    const scorecardData = reviewFeedback.cardScores.data ?? [];

    return (
      <div className="coaching-skill-velocity-chart-container">
        <CoachingSkillVelocityChart
          reviewData={reviewFeedback.reviewScores}
          scorecardData={scorecardData}
          skillBaseline={contentDetail.baseline}
          skillGoal={contentDetail.goal}
          planStart={planStart}
          planEnd={planEnd}
          currentReviewId={currentReviewId}
        />
      </div>
    );
  }
}

export default connectToStores(CoachingSkillVelocityChartContainer);
